import makeApiCall from "./axiosIndex";
const contractorsApis = {
  fetchContractor: (): Promise<any> =>
    makeApiCall<any>({ method: "get", url: "/buyer/fetchContractor" }),
  deleteContractorById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "delete",
      url: `/buyer/deleteContractorById?id=${id}`,
    }),
  createContractor: (data: any): Promise<any> =>
    makeApiCall<any>({ method: "post", url: "/buyer/createContractor", data }),
  updateContractorById: (id: any, data: any): Promise<any> =>
    makeApiCall<any>({ method: "put", url: `/buyer/updateContractorById?id=${id}`, data }),
  fetchContractorById: (id: any): Promise<any> =>
    makeApiCall<any>({ method: "get", url: `/buyer/fetchCOntractorById?id=${id}` }),
  fetchContractorBySiteId: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/buyer/fetchContractorBySiteId",
      data,
    }),
};

export default contractorsApis;
